export function createRegexFromFormat(formatString: string): RegExp {
  let escapedFormat = formatString.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

  // Replace placeholders with appropriate regex patterns
  escapedFormat = escapedFormat
    .replace('\\{grade\\}', '(\\w+)')
    .replace('\\{unit\\}', '(\\d+)')
    .replace('\\{module\\}', '(\\d+)')
    .replace('\\{lesson\\}', '(\\d+)')
    .replace('\\{character\\}', '(\\d+)')
    .replace('\\{name\\}', '(.+)')
    .replace('\\{GRADE\\}', '(\\w+)')
    .replace('\\{UNIT\\}', '(\\d+)')
    .replace('\\{LESSON\\}', '(\\d+)')
    .replace('\\{CHARACTER\\}', '(\\d+)')
    .replace('\\{NAME\\}', '(.+)')

  // Replace any occurrence of a dash with a character class that matches -, –, —
  escapedFormat = escapedFormat.replace(/[-–—]/g, '[-–—]')

  return new RegExp('^' + escapedFormat + '$')
}

export function parseFilenameByFormat(
  filename: string,
  regex: RegExp,
  formatString: string,
) {
  const match = filename.match(regex)

  if (!match) {
    // eslint-disable-next-line no-console
    console.error('Filename does not match the format', filename, formatString)
    return null
  }

  // Extract the placeholder names from the format string
  const placeholderPattern = /\{(grade|unit|lesson|name|module|character)\}/g
  const formatParts = [...formatString.matchAll(placeholderPattern)].map(
    (m) => m[1],
  )

  const parsedData: { [key: string]: string } = {}
  formatParts.forEach((part, index) => {
    parsedData[part] = match[index + 1]
  })

  return parsedData
}
